var _defs, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAnghami(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0linear3042120",
    x1: 12.0772,
    y1: 22.004,
    x2: 12.0772,
    y2: 2.06764,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DA3D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#9B2CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA4E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1linear3042120",
    x1: 8.81041,
    y1: 17.2785,
    x2: 8.81041,
    y2: 6.78913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DA3D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#9B2CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA4E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2linear3042120",
    x1: 11.8112,
    y1: 17.1137,
    x2: 11.8112,
    y2: 7.03441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DA3D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#9B2CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA4E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3linear3042120",
    x1: 14.0123,
    y1: 15.089,
    x2: 14.0123,
    y2: 8.96241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DA3D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#9B2CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA4E0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4linear3042120",
    x1: 16.226,
    y1: 13.0409,
    x2: 16.226,
    y2: 11.0344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.015,
    stopColor: "#DA3D94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.542,
    stopColor: "#9B2CD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2DA4E0"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0685 12.0428C22.1787 17.4052 17.6715 22.0109 12.0843 22C6.54124 21.989 2.07812 17.4819 2.07812 12.0209C2.07812 6.54879 6.59634 2.05271 12.0953 2.06368C17.6935 2.06368 22.2117 6.72425 22.0685 12.0428ZM3.76419 12.0428C3.60991 16.3853 7.37876 20.3331 11.9961 20.3551C16.6356 20.377 20.4816 16.7253 20.4706 12.0099C20.4595 7.20676 16.5144 3.69762 12.0843 3.68665C7.46692 3.68665 3.59889 7.63443 3.76419 12.0428Z",
    fill: "url(#paint0linear3042120)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.80021 12.01C8.63491 11.7359 8.39247 11.5604 8.19411 11.3521C6.80558 9.94842 7.23536 7.67844 9.03163 6.88889C9.69283 6.59281 10.2769 6.95469 10.2769 7.66748C10.2879 10.5515 10.2879 13.4356 10.2769 16.3197C10.2769 17.1531 9.70386 17.4821 8.94347 17.1421C7.91861 16.6816 7.37862 15.8591 7.33454 14.7954C7.29046 13.8962 7.66515 13.0847 8.39247 12.4925C8.52471 12.35 8.70103 12.2403 8.80021 12.01Z",
    fill: "url(#paint1linear3042120)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4701 12.0321V16.0786C12.4701 16.2431 12.4701 16.4076 12.4371 16.5721C12.371 16.8901 12.1175 17.0984 11.82 17.1094C11.5114 17.1204 11.2249 16.8901 11.1588 16.5611C11.1367 16.4514 11.1367 16.3418 11.1367 16.2321C11.1367 13.4906 11.1477 10.76 11.1477 8.01854C11.1477 7.81018 11.1698 7.61279 11.2469 7.42637C11.3571 7.16319 11.6106 6.9987 11.8971 7.02063C12.1616 7.04256 12.415 7.25092 12.4591 7.53603C12.4812 7.67859 12.4812 7.83212 12.4812 7.97467C12.4812 9.3235 12.4812 10.6723 12.4701 12.0321C12.4812 12.0321 12.4812 12.0321 12.4701 12.0321Z",
    fill: "url(#paint2linear3042120)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3518 12.0316V9.95897V9.79448C13.3739 9.26811 13.6273 8.96106 14.0241 8.97202C14.4208 8.98299 14.6742 9.29004 14.6742 9.82738C14.6853 11.3078 14.6742 12.7772 14.6742 14.2577C14.6742 14.3344 14.6742 14.4002 14.6632 14.477C14.5971 14.8718 14.2996 15.1349 13.9579 15.102C13.6053 15.0691 13.3518 14.806 13.3408 14.4002C13.3408 13.5997 13.3408 12.8101 13.3518 12.0316C13.3518 12.0316 13.3408 12.0316 13.3518 12.0316Z",
    fill: "url(#paint3linear3042120)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5557 12.0097C15.5557 11.8671 15.5447 11.7136 15.5557 11.571C15.5998 11.253 15.7871 11.0775 16.0957 11.0337C16.4153 10.9898 16.6467 11.0885 16.7679 11.3846C16.9442 11.8013 16.9442 12.2399 16.7789 12.6676C16.6577 12.9747 16.3932 13.0843 16.0516 13.0185C15.7541 12.9637 15.5888 12.7773 15.5557 12.4483C15.5337 12.3057 15.5557 12.1632 15.5557 12.0097Z",
    fill: "url(#paint4linear3042120)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnghami);
export default __webpack_public_path__ + "static/media/anghami.47ed49b9.svg";
export { ForwardRef as ReactComponent };